import { variables } from "../variables";

export default {
    state: {
        address: null,
        proofAddress: null,
        documentacionRestante: []
    },
    getters: {
        getAddress: (state) => {
            return state.address
        },
        getProofAddress: (state) => {
            return state.proofAddress
        },
        getDocumentacionRestante: (state) =>{
            return state.documentacionRestante
        }
    },
    mutations: {
        setAddress(state, header){
            state.address = header
        },
        setProofAddress(state, header){
            state.proofAddress = header
        },
        setDocumentacionRestante(state, header){
            state.documentacionRestante = header;
        }
    },
    actions: {
        async obtainLocationsDoc(context, cp){
            let response = await context.rootGetters.api.get(variables.serverUrl+'/api/v1/locations/'+cp)
            return response;
        },
        async obtainLocationByID(context, id){
            let response = await context.rootGetters.api.get(variables.serverUrl+'/api/v1/locations/'+id+'/specific')
            return response;
        },
        async applicantRemaining(context, body){
            let response = await context.rootGetters.api.post(variables.serverUrl+'/api/v1/applications/remaining-data', body)
            return response
        },
        async postBeneficiaries(context, body){
            let response = await context.rootGetters.api.post(variables.serverUrl+"/api/v1/beneficiaries", body)
            return response;

        }, 
        async postBeneficiariesRemaining(context, body){
            let response = await context.rootGetters.api.post(variables.serverUrl+"/api/v1/beneficiaries/remaining-data", body)
            return response;
        },
        async sendFinish(context){
            let response = await context.rootGetters.api.post(variables.serverUrl+"/api/v1/applications/complete", {})
            return response;

        }
    }
}